var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMarket = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 26,
  viewBox: "0 0 26 26",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  clipPath: "url(#clip0_1345_1162)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M12.5703 25.5259C5.67746 25.5259 0.0703125 19.9187 0.0703125 13.0259C0.0703125 6.13302 5.67746 0.525879 12.5703 0.525879C19.4632 0.525879 25.0703 6.13302 25.0703 13.0259C25.0703 19.9187 19.4632 25.5259 12.5703 25.5259ZM12.5703 4.09731C7.64174 4.09731 3.64174 8.09731 3.64174 13.0259C3.64174 17.9545 7.64174 21.9545 12.5703 21.9545C17.4989 21.9545 21.4989 17.9545 21.4989 13.0259C21.4989 8.09731 17.4989 4.09731 12.5703 4.09731Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M12.57 18.383C9.62361 18.383 7.21289 15.9723 7.21289 13.0258C7.21289 10.0794 9.62361 7.6687 12.57 7.6687C15.5165 7.6687 17.9272 10.0794 17.9272 13.0258C17.9272 15.9723 15.5165 18.383 12.57 18.383ZM12.57 11.2401C11.5879 11.2401 10.7843 12.0437 10.7843 13.0258C10.7843 14.008 11.5879 14.8116 12.57 14.8116C13.5522 14.8116 14.3557 14.008 14.3557 13.0258C14.3557 12.0437 13.5522 11.2401 12.57 11.2401Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1345_1162"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 25,
  fill: "white",
  transform: "translate(0.0703125 0.525879)"
})))));
export default SvgIconMarket;